/**
 * Re-export from the shared schema-driven hook.
 * All message type data comes from FlatBuffer enums, not the backend /message-type/ API.
 */
import { useSchemaMessageTypes } from "../useSchemaMessages";

/**
 * Fetches the message-type list, delegating to the schema-backed hook.
 */
export default function useGetAllMessagesTypes() {
  return useSchemaMessageTypes();
}
